export const siteConfig = {
  dateFormat: 'LLL d, yyyy',
  dateTimeFormat: 'LLL d, yyyy h:mmaaa',
  table: {
    limit: 25,
  },
  landingUrl: 'https://hydrascore.com/',
  upgradeUrl:'/profile?upgrade',
} as const